import React from "react";
import { Container} from 'react-bootstrap'
import loadable from "@loadable/component"

import RentalYieldCalculator from "./RentalYieldCalculator"
import MortgageCalculator from "./MortgageCalculator"

import "./StaticPageCalculator.scss";


const Select = loadable(() => import("react-select"));

const StaticPageCalculator = ({Module}) => {

    return (
        <React.Fragment>
            <section className="calculator-section">
                <Container>
                    <div className="calculator-wrapper">
                        {Module?.title && <h2>{Module?.title}</h2> }
                        {Module?.content && <p>{Module?.content}</p>}
                        
                        {Module?.calculator_type === "mortgage_calculator" && <MortgageCalculator />}
                        {Module?.calculator_type === "rental_yield_calculator" && <RentalYieldCalculator />}
                        
                    </div>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default StaticPageCalculator;
